"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._putStockpileConfigData = exports._getStockpileConfigData = void 0;
const axios_1 = __importDefault(require("axios"));
const error_response_1 = require("utils/error-response");
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const _getStockpileConfigData = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/configuration/checkpoint';
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? (sort.length > 0 ? JSON.stringify(sort) : undefined) : undefined;
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: err.isError,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0,
        };
    }
});
exports._getStockpileConfigData = _getStockpileConfigData;
const _putStockpileConfigData = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/configuration/checkpoint/${arg.id}`;
    const payload = {
        brand1_id: arg.brand1_id,
        brand2_id: arg.brand2_id,
        brand3_id: arg.brand3_id,
        brand4_id: arg.brand4_id,
        brand5_id: arg.brand5_id,
    };
    try {
        const { data } = yield axios_1.default.put(url, payload, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            },
        });
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: data.errorCode,
            data: {
                id: data.data.id,
            },
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: err.isError,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: {
                id: '',
            },
        };
    }
});
exports._putStockpileConfigData = _putStockpileConfigData;
